<template>
  <div v-if="user">
    <h2 class="section-title">
      {{ user.email }}
    </h2>

    <membership
      v-for="membership in user.memberships"
      :key="membership.id"
      :membership="membership"
    />

    <membership-modal />

    <button
      class="add-content-button"
      @click.prevent="openMembershipModal(user)"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import fullName from '@/filters/fullName'
import Membership from '@/components/memberships/Membership'
import MembershipModal from '@/components/memberships/MembershipModal'

export default {
  name: 'ClientMembersDetail',
  components: {
    Membership,
    MembershipModal
  },
  filters: {
    fullName
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
    })
  },
  methods: {
    ...mapActions([
      'fetchUser',
      'resetUser',
      'openMembershipModal',
    ]),
    ...mapActions({
      loadingDone: 'app/loadingDone'
    }),
  },
  created () {
    const userId = this.$route.params.memberId
    this.fetchUser(userId)
      .then(() => {
        this.loadingDone()
      })
  },
  beforeDestroy () {
    this.resetUser()
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/clients/ClientMembersDetailPage.vue